export const Role = {
    // application roles
    user: 'user',

    // project roles
    owner: 'owner',
    admin: 'admin',
    developer: 'developer',
    translator: 'translator',
}
